import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs';
import { AuthService } from '../../../shared/services/auth.service';
import { AppService } from '../../../shared/services/app.service';

@Component({
  selector: 'app-ml',
  templateUrl: './ml.component.html',
  styleUrl: './ml.component.scss',
})
export class MlComponent implements OnInit {
  // Tabs view entitlement
  readonly viewMlRelatedTabs: string[] = ['app.dcr-portal.ml.all'];
  selectedIndex = 0;

  tabs = [
    { name: 'Build Model', value: 'build', isVisibleForViewOnly: false },
    { name: 'Model History', value: 'history', isVisibleForViewOnly: true },
    { name: 'View Model', value: 'view-model', isVisibleForViewOnly: false },
  ];

  activeTabs?: any[];

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public authService: AuthService,
    public appService: AppService,
  ) {}

  ngOnInit() {
    if (this.appService.isEngagementActive) {
      this.activeTabs = [...this.tabs];
    } else {
      this.activeTabs = this.tabs.filter((tab) => tab.isVisibleForViewOnly);
    }

    this.router.events.pipe(filter((e) => e instanceof NavigationEnd)).subscribe(() => {
      const current = this.activatedRoute.firstChild?.snapshot.url[0]?.path;
      if (current) {
        this.selectedIndex = this.getTabIndexForRoute(current);

        if (current === 'view-model') {
          this.selectedIndex = this.getTabIndexForRoute('build');
        }
      }
    });

    const parentPath = this.activatedRoute.snapshot.url[0]?.path;

    let initial = this.activatedRoute.firstChild?.snapshot.url[0]?.path;

    if (parentPath === 'ml') {
      initial = this.activeTabs[0].value;
    }

    if (initial) {
      this.router.navigate([initial], { relativeTo: this.activatedRoute });
    }
  }

  private getTabIndexForRoute(routePath: string): number {
    return this.activeTabs?.findIndex((tab) => tab.value === routePath) || 0;
  }

  onTabChange(index: number) {
    const currentRoute = this.activatedRoute.firstChild?.snapshot.url[0]?.path;
    const targetRoute = this.activeTabs![index].value;
    if (currentRoute === 'view-model' && targetRoute === 'build') {
      return;
    }

    this.router.navigate([targetRoute], { relativeTo: this.activatedRoute });
  }
}
